export default __webpack_public_path__ + "static/remo-hunziker-7f901a11b1b6d362d16daca0d595d08b.jpg";